import variable from './variable.vue';
import message from './message.vue';
import { sceneConfigAdd, sceneConfigEdit } from '../request';
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    variables: {
      type: Object,
      default: () => {}
    },
    sceneListId: {
      type: String | Number,
      default: ''
    },
    allMessageList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        title: undefined,
        code: '',
        content: ''
      },
      loading: false,
      btnShow: 2,
      isEdit: false,
      copyItem: null
    };
  },
  watch: {
    item: {
      handler(val) {
        this.form = {
          title: undefined,
          content: '',
          code: ''
        };
        this.copyItem = JSON.parse(JSON.stringify(val));
        if (val && !val.id) {
          this.btnShow = 1;
          this.isEdit = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    variable,
    message
  },
  methods: {
    setFormData(val) {
      this.form = {
        title: val.title || undefined,
        code: val.code,
        content: val.content
      };
    },
    saveForm() {
      var _childForm$$refs;
      let childForm = this.$refs.messageForm;
      (_childForm$$refs = childForm.$refs) === null || _childForm$$refs === void 0 || _childForm$$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.form = childForm.form;
          let params = {
            sceneListId: this.sceneListId,
            title: this.form.title,
            code: this.form.code,
            content: this.form.content,
            language: this.language,
            type: this.type,
            isSystemTemplate: 1
          };
          if (this.copyItem.id) {
            params.sceneConfigId = this.copyItem.id;
            this.loading = true;
            sceneConfigEdit(params).then(res => {
              this.$message.success(this.$t('保存成功'));
              this.saveStatusUpdate();
            }).finally(() => {
              this.loading = false;
            });
          } else {
            this.loading = true;
            sceneConfigAdd(params).then(res => {
              if (res.sceneConfigId) {
                this.$message.success(this.$t('保存成功'));
                this.saveStatusUpdate();
                this.updateData();
                this.$set(this.copyItem, 'id', res.sceneConfigId);
              }
            }).finally(() => {
              this.loading = false;
            });
          }
        }
      });
    },
    saveStatusUpdate() {
      this.btnShow = 2;
      this.isEdit = false;
    },
    updateData() {
      //保存后更新状态
      this.$set(this.copyItem, 'title', this.form.title);
      this.$set(this.copyItem, 'content', this.form.content);
      this.$set(this.copyItem, 'code', this.form.code);
    },
    editForm() {
      this.btnShow = 3;
      this.isEdit = true;
    },
    cancelForm() {
      this.copyItem = JSON.parse(JSON.stringify(this.copyItem));
      this.saveStatusUpdate();
    }
  }
};